import {Component} from '@angular/core';
import {AuthService} from "../_services/auth.service";
import {Router} from "@angular/router";
import {Community} from "../_types/communities";
import {LocalStorageService} from "../_services/local-storage.service";

@Component({
    selector: 'app-notfound',
    templateUrl: './notfound.component.html',
    styleUrls: ['./notfound.component.scss']
})
export class NotfoundComponent {

    constructor(private authService: AuthService, private router: Router, private localStorageService: LocalStorageService) {
    }

    get lastSelectedCommunity(): Community | null {
        return this.localStorageService.getItem<Community | null>('lastSelectedCommunity', null);
    }

    goToHome(): void {
        if (this.authService.isLoggedIn()) {
            //  LoginUser has token can go to auth view
            if (this.lastSelectedCommunity?.default_page_is_feed) {
                this.router.navigate(['/feed']);
            } else {
                this.router.navigate(['/dashboard']);
            }
        } else {
            //  LoginUser has no token can't go to auth view
            this.authService.logout();
        }
    }

}
